<template>
    <path d="M 17.618983,3.3220339 12,8.941017 6.381017,3.3220339 3.3220339,6.381017 8.941017,12 3.3220339,17.618983 6.381017,20.677967 12,15.058983 17.618983,20.677967 20.677967,17.618983 15.058983,12 20.677967,6.381017 Z"/>
</template>

<script>
    export default {
        name: 'error',
    }
</script>



// WEBPACK FOOTER //
// src/components/icon/Error.vue